export default __webpack_public_path__ + "ff5c2f536f85819035e9b62461468aea.svg";